import { CreateApplicationDto } from 'screens/Billing/FinancialAssistance/FAApplication/FAComplete/components/types';
import { AddressValues } from 'screens/Profile/EditAddress';
import { BasicInfoForm, HouseholdForm, AssetsForm, BillsForm, CompleteForm } from './types';

export const SET_FA_FORM_1_BASIC_INFO = 'FA.SET_FA_FORM_1_BASIC_INFO';
export const setFAForm1BasicInfo = (validData: BasicInfoForm) => ({
  type: SET_FA_FORM_1_BASIC_INFO,
  payload: validData
});

export const SET_FA_FORM_2_HOUSEHOLD = 'FA.SET_FA_FORM_2_HOUSEHOLD';
export const setFAForm2Household = (validData: HouseholdForm) => ({
  type: SET_FA_FORM_2_HOUSEHOLD,
  payload: validData
});

export const SET_FA_FORM_3_ASSETS = 'FA.SET_FA_FORM_3_ASSETS';
export const setFAForm3Assets = (validData: AssetsForm) => ({
  type: SET_FA_FORM_3_ASSETS,
  payload: validData
});

export const SET_FA_FORM_4_BILLS = 'FA.SET_FA_FORM_4_BILLS';
export const setFAForm4Bills = (validData: BillsForm) => ({
  type: SET_FA_FORM_4_BILLS,
  payload: validData
});

export const SET_FA_FORM_5_COMPLETE = 'FA.SET_FA_FORM_5_COMPLETE';
export const setFAForm5Complete = (validData: CompleteForm) => ({
  type: SET_FA_FORM_5_COMPLETE,
  payload: validData
});

export const SET_FA_FORM_CLEAR = 'FA.SET_FA_FORM_CLEAR';
export const setFAFormClear = () => ({
  type: SET_FA_FORM_CLEAR
});

export const FA_FORM_SEND = 'FA.FA_FORM_SEND';
export const FA_FORM_SEND_SUCCESS = 'FA.FA_FORM_SEND_SUCCESS';
export const FA_FORM_SEND_FAIL = 'FA.FA_FORM_SEND_FAIL';
export const submitFAForm = (createApplicationDto: CreateApplicationDto) => ({
  type: FA_FORM_SEND,
  payload: {
    client: 'financialAssistance',
    request: {
      method: 'post',
      url: '/',
      data: createApplicationDto
    }
  }
});

export const UPDATE_FA_FORM_PROFILE = 'FA.UPDATE_FA_FORM_PROFILE';
export const updateFAFormProfile = (validData: AddressValues) => ({
  type: UPDATE_FA_FORM_PROFILE,
  payload: validData
});

export const EDITING_FA_FORM_PROFILE = 'FA.EDITING_FA_FORM_PROFILE';
export const setEditingFAFormProfile = (validData: boolean) => ({
  type: EDITING_FA_FORM_PROFILE,
  payload: validData
});
